import { useMemo } from 'react';
import { getWidgetStores } from '@/entities/widget';
import { inlineWidgetsOf, type InlineWidget } from '../../model/inline-widgets';
import { useWidgetActions } from '../../model/useWidgetActions';
import { HtmlWidgetFrame } from '../HtmlWidgetFrame/HtmlWidgetFrame';

function InlineWidgetFrame({ item, contextId }: { item: InlineWidget; contextId?: string }) {
  const onAction = useWidgetActions(item);
  return (
    <HtmlWidgetFrame
      widget={item.widget}
      artifactId={item.artifactId}
      contextId={contextId}
      onAction={onAction}
    />
  );
}

/** The inline widgets of one agent reply, mounted by the chat through its inline-widgets seam. */
export function InlineHtmlWidgets({ messageId }: { messageId: string }) {
  const { widgetStore, chatStore } = getWidgetStores();
  const histories = widgetStore.useWidgetStore((state) => state.agentHistories);
  const contextId = chatStore.useChatId() ?? undefined;
  const widgets = useMemo(() => inlineWidgetsOf(histories, messageId), [histories, messageId]);

  if (widgets.length === 0) return null;
  return (
    <div className="mt-3 flex flex-col gap-3">
      {widgets.map((item) => (
        <InlineWidgetFrame key={item.key} item={item} contextId={contextId} />
      ))}
    </div>
  );
}
